import RecapNewMarkdowns from 'components/Content/Recap/RecapNewMarkdowns/RecapNewMarkdowns';

export default RecapNewMarkdowns;
